import { useState , useEffect, useContext } from 'react';
import { EquipamentosContext } from '../../../contexts/equipamentosProvider';
import { BiEdit } from 'react-icons/bi';
import AlterModal from './alterModal';
import BaseButton from '../../General/FormsComp/Button/BaseButton';

const EquipamentoTable = ({ dados, cliente }) => {
    const { gerarRelatorio } = useContext(EquipamentosContext);
    const [grupos, setGrupos] = useState(null);
    const [isAlterarModalOpen, setIsAlterarModalOpen] = useState(false);
    const [selectedGrupo, setSelectedGrupo] = useState(null);

    useEffect(() => {
      let newGrupos = dados ? [...dados] : [];
      newGrupos = newGrupos.map((grupo) => {
        grupo.maxEquipamentos = grupo.maxEquipamentos || 0;
        return grupo;
      });
      setGrupos(newGrupos);
    }, [dados]);

    const handleAlterarModal = (grupo) => {
      if(!isAlterarModalOpen){
        setSelectedGrupo(grupo);
        setIsAlterarModalOpen(true);
      }else{
        setSelectedGrupo(null);
        setIsAlterarModalOpen(false);
      }
    };

    const handleGerarRelatorio = () => {
      gerarRelatorio(cliente.id);
    }

    const getProgressColor = (totalPats, maxEquipamentos) => {
      if (totalPats > maxEquipamentos) {
        return {
          bg: 'bg-red-100 dark:bg-red-900/20',
          bar: 'bg-red-500',
          text: 'text-red-700 dark:text-red-400'
        };
      } else if (totalPats < maxEquipamentos) {
        return {
          bg: 'bg-blue-100 dark:bg-blue-900/20',
          bar: 'bg-blue-500',
          text: 'text-blue-700 dark:text-blue-400'
        };
      } else {
        return {
          bg: 'bg-green-100 dark:bg-green-900/20',
          bar: 'bg-green-500',
          text: 'text-green-700 dark:text-green-400'
        };
      }
    };

    return (
      <div className="space-y-6">
        {grupos && grupos.length > 0 ? (
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gray-50 dark:bg-gray-700">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">#</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Grupo Equipamento</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Quantidade Total</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Instalados/Disponíveis</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Ação</th>
                  </tr>
                </thead>
                <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                  {grupos.map((grupoCliente, i) => {
                    const { grupoNome, totalPatrimoniosNfs, totalPatrimonios, maxEquipamentos } = grupoCliente;
                    const totalPats = totalPatrimoniosNfs + totalPatrimonios;
                    const progress = maxEquipamentos > 0 ? (totalPats / maxEquipamentos) * 100 : 0;
                    const colors = getProgressColor(totalPats, maxEquipamentos);

                    return (
                      <tr key={i} className="hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-200">
                        <td className="px-6 py-4 whitespace-nowrap">
                          <span className="inline-flex items-center justify-center w-8 h-8 bg-vox-blue-100 dark:bg-vox-blue-900/20 text-vox-blue-800 dark:text-vox-blue-200 rounded-full text-sm font-medium">
                            {i + 1}
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="text-sm font-medium text-gray-900 dark:text-white">{grupoNome}</div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="text-sm text-gray-900 dark:text-white font-semibold">{totalPats}</div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="space-y-2">
                            <div className={`text-sm font-semibold ${colors.text}`}>
                              {totalPats} / {maxEquipamentos}
                            </div>
                            <div className="w-full bg-gray-200 dark:bg-gray-600 rounded-full h-2">
                              <div 
                                className={`${colors.bar} h-2 rounded-full transition-all duration-300`}
                                style={{ width: `${Math.min(progress, 100)}%` }}
                                title={`${progress.toFixed(1)}% utilizado`}
                              />
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <button
                            onClick={() => handleAlterarModal(grupoCliente)}
                            className="p-2 text-gray-500 hover:text-vox-blue-600 dark:text-gray-400 dark:hover:text-vox-blue-400 transition-colors duration-200 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700"
                            title="Alterar limite contratado"
                          >
                            <BiEdit className="w-5 h-5" />
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-12">
            <div className="text-center">
              <div className="text-gray-400 dark:text-gray-500 text-6xl mb-4">📊</div>
              <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
                Nenhum equipamento encontrado
              </h3>
              <p className="text-gray-500 dark:text-gray-400 mb-6">
                Gere um relatório para visualizar os equipamentos deste cliente
              </p>
              <BaseButton onClick={handleGerarRelatorio} variant="primary" size="lg">
                Gerar Relatório
              </BaseButton>
            </div>
          </div>
        )}

        {grupos && grupos.length > 0 && (
          <div className="flex justify-center">
            <BaseButton onClick={handleGerarRelatorio} variant="secondary" size="md">
              Atualizar Relatório
            </BaseButton>
          </div>
        )}
    
        {isAlterarModalOpen && (
          <AlterModal closeModal={handleAlterarModal} grupo={selectedGrupo} />
        )}
      </div>
    );
    
};

export default EquipamentoTable;
